import {
  Container,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { TransactionsViewModel } from "./TransactionsViewModel";
import { provideGetAllTransactionsUseCase } from "../../di/UseCasesModule";
import { HeaderView } from "../../component/HeaderView";
import { useTranslation } from "react-i18next";
import { LoadingView } from "../../component/LoadingView";
import { COLOR_VERY_LIGHT_GRAY } from "../../../data/colors/Colors";
import { CustomTextView } from "../../component/CustomTextView";
import moment from "moment";
import { EmptyView } from "../../component/EmptyView";
import "moment/locale/ar";

export function TransactionsView() {
  const { t, i18n } = useTranslation();
  const viewModel = TransactionsViewModel(provideGetAllTransactionsUseCase());

  return (
    <Stack>
      <HeaderView
        title={t("transactions")}
        isLayoutFullWidthInSmallerScreens={false}
      />

      <Container maxWidth={false} sx={{ pt: 3, pb: 3 }}>
        {viewModel.loading && viewModel.transactions?.length === 0 ? (
          <LoadingView />
        ) : (
          <>
            {viewModel.transactions && viewModel.transactions.length > 0 ? (
              <TableContainer
                component={Paper}
                sx={{
                  borderRadius: 8,
                  background: COLOR_VERY_LIGHT_GRAY,
                  boxShadow: 0,
                  padding: 2,
                }}
              >
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <CustomTextView
                          text={t("number")}
                          fontWeight="bold"
                          fontSize={16}
                        />
                      </TableCell>
                      <TableCell>
                        <CustomTextView
                          text={t("original_price_in_usd")}
                          fontWeight="bold"
                          fontSize={16}
                        />
                      </TableCell>
                      <TableCell>
                        <CustomTextView
                          text={t("price_qr")}
                          fontWeight="bold"
                          fontSize={16}
                        />
                      </TableCell>
                      <TableCell>
                        <CustomTextView
                          text={t("number_of_games")}
                          fontWeight="bold"
                          fontSize={16}
                        />
                      </TableCell>
                      <TableCell>
                        <CustomTextView
                          text={t("discount")}
                          fontWeight="bold"
                          fontSize={16}
                        />
                      </TableCell>
                      <TableCell>
                        <CustomTextView
                          text={t("created")}
                          fontWeight="bold"
                          fontSize={16}
                        />
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {viewModel.transactions.map((transaction, index) => (
                      <TableRow
                        key={transaction._id}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          <CustomTextView
                            text={`#${index + 1}`}
                            fontSize={18}
                          />
                        </TableCell>
                        <TableCell>
                          <CustomTextView
                            text={`$${transaction.originalPriceInUSD}`}
                            fontSize={18}
                          />
                        </TableCell>
                        <TableCell>
                          <CustomTextView
                            text={transaction.invoiceDisplayValue}
                            fontSize={18}
                          />
                        </TableCell>
                        <TableCell>
                          <CustomTextView
                            text={transaction.numberOfPurchasedGames.toString()}
                            fontSize={18}
                          />
                        </TableCell>
                        <TableCell>
                          <CustomTextView
                            text={`${transaction.discount}%`}
                            fontSize={18}
                            fontWeight={
                              transaction.discount > 0 ? "bold" : "normal"
                            }
                          />
                        </TableCell>
                        <TableCell>
                          <CustomTextView
                            text={moment(transaction.createdAt)
                              .locale(i18n.resolvedLanguage ?? "ar")
                              .fromNow()}
                            fontSize={18}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <EmptyView />
            )}
          </>
        )}
      </Container>
    </Stack>
  );
}
